import React, { createContext, useContext, useMemo } from 'react';
import MockDataService from '../services/MockDataService';
import ApiDataService from '../services/ApiDataService';

/**
 * DATA CONTEXT - DEPENDENCY INJECTION PATTERN
 * 
 * Purpose: Switch between mock and real API data
 * - Development: Can use mock data for faster development
 * - Production: Uses real API calls to backend
 * - Environment based switching
 */

const DataContext = createContext();

export const useDataService = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useDataService must be used within a DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  // Switch to API service for backend integration
  // Default to API service now that backend is ready
  const dataService = useMemo(() => {
    const USE_API = process.env.REACT_APP_USE_API !== 'false'; // Default to API
    console.log('Using API service:', USE_API);
    return USE_API ? new ApiDataService() : new MockDataService();
  }, []);

  return (
    <DataContext.Provider value={dataService}>
      {children}
    </DataContext.Provider>
  );
};